import React from "react";
import { motion } from "framer-motion";

const titleVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] },
  },
};

/**
 * En-tête de section partagé : numéro fantôme éditorial + kicker + titre serif.
 * Le numéro filé (02, 03, 04...) crée un fil conducteur visuel entre les
 * sections, à la place d'un simple titre centré générique.
 */
const SectionHeading = ({
  index,
  kicker,
  title,
  description,
  className = "",
}) => (
  <motion.div
    className={`relative mb-8 sm:mb-10 md:mb-12 ${className}`}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: "-80px" }}
    variants={titleVariants}
  >
    {index && (
      <span
        className="absolute -top-4 sm:-top-8 right-0 font-poster text-7xl sm:text-9xl lg:text-[10rem] font-extrabold text-ink-900/[0.05] select-none pointer-events-none leading-none"
        aria-hidden
      >
        {index}
      </span>
    )}
    {kicker && (
      <p className="text-ember-700 text-xs sm:text-sm font-bold uppercase tracking-[0.2em] mb-3">
        {kicker}
      </p>
    )}
    <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-ink-900 max-w-2xl leading-[1.1]">
      {title}
    </h2>
    {description && (
      <p className="text-ink-500 text-sm sm:text-base mt-4 max-w-xl leading-relaxed">
        {description}
      </p>
    )}
  </motion.div>
);

export default SectionHeading;
